import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-success-failure',
  templateUrl: './success-failure.component.html',
  styleUrls: ['./success-failure.component.css']
})
export class SuccessFailureComponent {

  constructor(public dialogRef: MatDialogRef<SuccessFailureComponent>, @Inject(MAT_DIALOG_DATA) public modalData: any) { }

  close() {
    this.dialogRef.close();
  }

  confirm() {
    this.dialogRef.close('Confirm');
  }

}
